import {
  fetchDetail,
  fetchDelete,
  fetchCreate,
  fetchEdit,
} from '@/api/course';
import AuthResponse from '@/service/AuthResponse';
import Notifications from '@/service/Notifications';

export default {
  fetch(context, id) {
    const { commit } = context;
    commit('setIsLoading', true);
    commit('reset');
    return fetchDetail(id)
      .then(res => AuthResponse.validate(res, context))
      .then(res => {
        if (!res) {
          return;
        }
        commit('setIsLoading', false);
        commit('setItem', res);
        return res;
      })
      .catch(e => Notifications.error(
          e.toString() || 'Failed to retrieve course',
          () => commit('reset')
        )
      )
    ;
  },
  remove({ state, commit, dispatch }, id = null) {
    commit('setIsLoading', true);
    if (!id) {
      id = state.item.id;
    }
    return fetchDelete(id)
      .then(res => AuthResponse.validateDelete(res, dispatch))
      .catch(e => Notifications.error(
        e.toString() || `Failed to delete course: ${id}`,
        () => commit('reset')
        )
      )
      ;
  },
  save({ state, dispatch }) {
    return state.item.id ? dispatch('update') : dispatch('create');
  },
  create(context) {
    const { commit, getters } = context;
    commit('setIsLoading', true);
    return fetchCreate(getters.payload)
      .then(res => AuthResponse.validate(res, context))
      .then(res => {
        if (!res) {
          return;
        }
        commit('setIsLoading', false);
        commit('setItem', res);
        return res;
      })
      .catch(e => Notifications.error(
        e.toString() || 'Failed to create course',
        () => commit('reset')
        )
      )
      ;
  },
  update(context) {
    const { commit, getters } = context;
    commit('setIsLoading', true);
    return fetchEdit(getters.payload)
      .then(res => AuthResponse.validate(res, context))
      .then(res => {
        if (!res) {
          return;
        }
        commit('setIsLoading', false);
        commit('setItem', res);
        return res;
      })
      .catch(e => Notifications.error(
        e.toString() || `Failed to save course: ${getters.payload.id}`,
        () => commit('reset')
        )
      )
      ;
  },
};
